var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLupaPesquisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.566,
    height: 27.566,
    viewBox: "0 0 27.566 27.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 27.566,
    height: 27.566,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M18.914,20.674h0L13,14.776v-.934l-.319-.331a7.694,7.694,0,1,1,.828-.828l.331.319h.934l5.9,5.911-1.76,1.76ZM7.683,2.364A5.319,5.319,0,1,0,13,7.683,5.325,5.325,0,0,0,7.683,2.364Z",
    transform: "translate(3.446 3.362)",
    fill: "#005288"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupaPesquisa);
export default __webpack_public_path__ + "static/media/lupa_pesquisa.c1e61d69ec6ba74c62c06562b362f9ed.svg";
export { ForwardRef as ReactComponent };